exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scale[data-v-3fd6aea4]{position:absolute;bottom:10px;right:40px;text-align:right;font-size:24px;pointer-events:none}.scale-ruler[data-v-3fd6aea4]{float:right;height:4px;border:2px solid #fff;background:#6c6c6c}.scale .number[data-v-3fd6aea4]{clear:both;text-shadow:1px 1px 0 #fff,-1px -1px 0 #fff,-1px 1px 0 #fff,1px -1px 0 #fff,0 1px 0 #fff,0 -1px 0 #fff,-1px 0 0 #fff,1px 0 0 #fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3fd6aea4","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/map/scale_ruler.vue
// module id = 837
// module chunks = 0